import React, { FC, useCallback } from "react";
import { IconButton } from "@evergis/ui";
import { useTranslation } from "react-i18next";

import { useEditResourceDialog } from "../../hooks/useDialogs";
import { useResourceType } from "../../hooks/useResourceType";

interface ISettingsIconProps {
  disabled?: boolean;
  name?: string;
}

export const SettingsIcon: FC<ISettingsIconProps> = ({ disabled, name }) => {
  const { t } = useTranslation("common");
  const openEditResourceDialog = useEditResourceDialog();
  const [resourceType] = useResourceType();
  const openEditDialog = useCallback(() => openEditResourceDialog([name, resourceType]), [name, resourceType]);

  return <IconButton kind={"settings"} title={t("settings")} onClick={openEditDialog} disabled={disabled} />;
};
